import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=11b30797&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b30797",
  null
  
)

export default component.exports